import { Step, StepLabel, Stepper } from "@mui/material";

const steps = ["Details", "Memberships", "Cosmo Care", "Accessories", "Review"];

interface Props {
  activeStep: number;
}

const CustomStepper = ({ activeStep }: Props) => (
  <Stepper
    activeStep={activeStep}

    sx={{
      width: "60vw",
      maxWidth: "852px"
    }}
  >
    {steps.map((label) => (
      <Step key={label} >
        <StepLabel>
          {label}
        </StepLabel>
      </Step>
    ))}
  </Stepper>
);
export default CustomStepper;
